import React from 'react';
import { Link } from 'react-router-dom';

import { UserProfileTypes } from 'models/User';
import { ITableModel } from '../interface';
import { ITickets } from 'models/Ticket';

import Text from 'components/Text';
import { Button } from 'components/Button';

import { EnumToArray } from 'utils/enumArray/enumHelpers';
import iconEdit from 'img/edit-icon-table.svg';

import '../styles.scss';

const labelCategory = {
  label: 'Categoria',
  key: 'protocolCategory',
  size: 130,
  maxSize: 130,
  Component: (data: ITickets) => (
    <Text className="color-blue-gray first-letter-uppercase" size={12} showTip>
      {data.protocolCategory}
    </Text>
  ),
};

const labelReason = {
  label: 'Motivo',
  key: 'ticketReason',
  size: 120,
  Component: (data: ITickets) => (
    <Text className="color-blue-gray first-letter-uppercase" size={12} showTip>
      {data.ticketReason}
    </Text>
  ),
};

const labelOpenAt = {
  label: 'Aberto em',
  key: 'createdDate',
  type: 'date/hour',
  size: 130,
  maxSize: 130,
};

const labelOpenBy = {
  label: 'Por',
  key: 'userWhoCreated.fullName',
  noFilter: true,
};

const ticketsModelBasic: Array<ITableModel> = [
  labelCategory,
  labelReason,
  labelOpenAt,
  labelOpenBy,
];

function hideButton(ticket: ITickets) {
  return ticket.statusType === 'DONE';
}

type TextModelTicketProps = {
  ticket: ITickets;
};

const TextModelTicket = (props: TextModelTicketProps) => {

  const { ticket } = props;

  return (
    <Text className="color-blue-gray" size={12} showTip>
      {EnumToArray(UserProfileTypes).find(
        (item) =>
          item.key.toLowerCase() === ticket.responsibleGroup?.toLowerCase()
      )?.value ?? ''}
    </Text>
  );
};

const modelTicket: Array<ITableModel> = [
  { ...labelCategory, size: 140, maxSize: 140 },
  { ...labelReason },
  { label: 'Cliente', key: 'company.companyName', noFilter: true },
  labelOpenAt,
  labelOpenBy,
  {
    label: 'Grupo responsável',
    key: 'responsibleGroup',
    size: 120,
    maxSize: 120,
    Component: (data: ITickets) => (
      <TextModelTicket ticket={data} />
    ),
  },
  {
    label: 'Última interação',
    key: 'updatedDate',
    type: 'date/hour',
    size: 130,
    maxSize: 130,
  },
  { label: 'Status', key: 'phaseStatus' },
  {
    label: '',
    key: '',
    size: 50,
    maxSize: 50,
    isButton: true,
    Component: (data: ITickets) => (
      <Link
        to={{
          pathname: '/abrir-protocolo'
        }}
        state={data}
      >
        <Button width="auto" hide={hideButton(data)}>
          <img src={iconEdit} alt="" />
        </Button>
      </Link>
    ),
  },
];

const modelLinkTicket: Array<ITableModel> = [
  { ...labelCategory, size: 140, maxSize: 140 },
  { ...labelReason },
  labelOpenAt,
  labelOpenBy,
  {
    label: 'Grupo responsável',
    key: 'responsibleGroup',
    size: 120,
    maxSize: 120,
    Component: (data: ITickets) => (
      <TextModelTicket ticket={data} />
    ),
  },
  { label: 'Status', key: 'phaseStatus' },
];

export { ticketsModelBasic, modelTicket, modelLinkTicket };
